export default __webpack_public_path__ + "static/media/ucla-remote.e8645b12.png";